import {
  AccessRequest,
  UpdateAccessRequestStatus,
} from 'features/accessRequest/types'
import clientApi from '../../api/clientApi'

const apiEndpoint = process.env.REACT_APP_REPASSE_API_ENDPOINT

export const getAccessRequests = async (
  hospitalId: number
): Promise<AccessRequest[]> => {
  const { data } = await clientApi.get<AccessRequest[]>(
    `${apiEndpoint}/access-requests/${hospitalId}`
  )

  return data
}

export const requestAccess = (hospitalId: number) => {
  return clientApi.post(
    `${apiEndpoint}/access-requests?hospitalId=${hospitalId}`
  )
}

export const updateAccessRequest = (
  hospitalId: number,
  id: number,
  status: UpdateAccessRequestStatus
) => {
  return clientApi.patch(
    `${apiEndpoint}/access-requests/${hospitalId}/${id}`,
    {
      status,
    }
  )
}

export const revokeAccessRequestByDoctor = (
  hospitalId: number,
  doctorId: number
) => {
  return clientApi.patch(
    `${apiEndpoint}/access-requests/${hospitalId}/revoke`,
    {
      doctorId,
    }
  )
}
